import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/Auth'

const Logout = () => {
  const { logout } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    let isMounted = true

    const handleLogout = async () => {
      try {
        await logout()
        if (isMounted) {
          navigate('/auth')
        }
      } catch (error) {
        if (isMounted) {
          navigate('/auth')
        }
      }
    }

    handleLogout()

    return () => {
      isMounted = false
    }
  }, [logout, navigate])

  return null
}

export default Logout
